import { Component } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';

@Component({
    selector: 'app-applicationexception',
    templateUrl: './applicationexception.component.html',
    styleUrls: ['./applicationexception.component.scss'],
    standalone: false
})
export class ApplicationexceptionComponent {


  constructor(gerneralService: GeneralService) { }
	
  onNgViewInit() {
		window.onbeforeunload = null;
	}

}
